import { createFileRoute } from "@tanstack/react-router";

import BroadcastsCreateUpdate from "@/features/broadcasts/BroadcastsCreateUpdate";
import SideNavLayout from "@/layouts/SideNavLayout";
import { BroadcastsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/broadcasts/add/")({
  component: () => (
    <SideNavLayout menu={<BroadcastsMenu />}>
      <BroadcastsCreateUpdate key="create" />
    </SideNavLayout>
  ),
});
